/** Date labels for chart axes and tooltips (dates are ``YYYY-MM-DD``, UTC). */

export function formatDayShort(iso: string, locale?: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatDayLong(iso: string, locale?: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString(locale, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

/** Axis label for an effort duration: 5s, 1m, 20m (spec labels). */
export function formatEffortTick(sec: number): string {
  return sec < 60 ? `${sec}s` : `${Math.round(sec / 60)}m`;
}
